<template>
  <div>
    <a href="#" @click.prevent.stop="acessarCliente">
      <img
        :src="foto"
        class="img-fluid mb-2 rounded-circle"
        width="80"
        height="80"
      />
    </a>
    <div>{{ nome }}</div>
    <div>{{ email }}</div>
  </div>
</template>
<script>
import TooltipAniversarios from './js/tooltip-aniversarios'
export default TooltipAniversarios
</script>
